import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './_styles/ResultsPagination.module.scss';

const allActionCreators = Object.assign({});

export class ResultsPagination extends Component {

	getPageCount() {
		if(!parseInt(this.props.dataCount) || !parseInt(this.props.currentPageSize)) { return 1; }
		return Math.ceil(parseInt(this.props.dataCount) / parseInt(this.props.currentPageSize));
	}

	render() {
		return <div className={styles.ResultsPagination}>
			<div className={styles.paginationWrapper}>
				<div className={styles.navWrapper}>
					<div className={`${styles.arrowWrapper}`}>
						{this.props.currentPage > 1 && (
							<div className={`${styles.arrow} FlexCenter`} onClick={() => this.props.setPage(this.props.currentPage - 1)}>&lt;</div>
						)}
					</div>
					<div className={styles.pageStatus}>Page {this.props.currentPage || 1} of {this.getPageCount()}</div>
					<div className={`${styles.arrowWrapper}`}>
						{this.props.currentPage < this.getPageCount() && (
							<div className={`${styles.arrow} FlexCenter`} onClick={() => this.props.setPage(this.props.currentPage + 1)}>&gt;</div>
						)}
					</div>
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ResultsPagination);